<template>
    <div>
        <div class="head-main">
            <div class="main_in">
                <div class="main_in_left">
                    <img src="@/assets/img/logo.png" alt />
                    <a href="http://www.haichacha.net/">
                        <i class="el-icon-arrow-left"></i>返回官网主页
                    </a>
                </div>
                <div class="main_in_right">
                    <nav>
                        <ul class="menu">
                            <li>
                                <router-link to="/home">首页</router-link>
                            </li>
                            <li v-if="userInfo.role == 1" class="vip">
                                <router-link to="/vip/buy"><span>VIP</span>开通</router-link>
                            </li>
                            <li v-else-if="userInfo.role == 2 || (userInfo.role == 3&&userInfo.leader)" @click="showvip" class="vip">
                                <span>VIP</span>续费
                            </li>
                        </ul>
                    </nav>
                    <div class="user-drop">
                        <div class="drop-link" @mouseenter="enter()" @mouseleave="leave()">
                            <img src="@/assets/img/headImg.png">
                            {{userInfo.nickName}}
                            <i class="el-icon-caret-top el-icon--right" v-if="xufeiShow"></i>
                            <i class="el-icon-caret-bottom el-icon--right" v-else></i>
                        </div>
                        <div class="dropdown-con" v-if="xufeiShow" @mouseenter="enter()" @mouseleave="leave()">
                            <dl class="user-vip">
                                <dt>
                                    <div>{{userInfo.nickName}}</div>
                                    <span class="individual" v-if="userInfo.role==2">个人会员</span>
                                    <span class="company" v-else-if="userInfo.role==3">企业会员</span>
                                    <span class="normal" v-else-if="userInfo.role==1">普通会员</span>
                                </dt>
                                <dd v-if="userInfo.role==2 || (userInfo.role == 3 && userInfo.leader)">
                                    {{userInfo.expirationTime}} 到期
                                    <button @click="showvip">立即缴费</button>
                                </dd>
                            </dl>
                            <ul class="dropdown-item">
                                <li v-for="(item) in navlist" :key="item.index" @click="push(item.router)" v-show="!((item.index==2&&(userInfo.role==2||userInfo.role==3&&userInfo.leader)) || (item.index==3&&(userInfo.role!=3 ||(userInfo.role==3 && !userInfo.leader))))">
                                    {{ item.name }}
                                </li>
                                <li @click="exit()">退出账号</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <router-view></router-view>
        </div>
        <div class="footer">
            <div class="footer_in">
                <div style="display: flex;justify-content: center;align-items: center;">
                    <img src="@/assets/img/logo.png" alt="">
                </div>
                <div style="width: 340px">
                    <p class="h1">联系我们</p>
                    <p class="h2">Contact Us</p>
                    <p class="h3">地址：青岛市南区高雄路18号海洋大厦5层</p>
                    <p class="h3">电话：18563930999（郑经理）</p>
                    <p class="h3">邮箱：sunnyjun@vip.163.com</p>
                </div>
                <div>
                    <p class="h1">我们的业务</p>
                    <p class="h2">Service Us</p>
                    <p class="h3">
                        <a href="http://www.haichacha.net/index.php/index/category/index?id=108">产品功能</a>
                    </p>
                    <p class="h3">
                        <a href="http://www.haichacha.net/index.php/index/category/index?id=109">数据智能</a>
                    </p>
                </div>
                <div>
                    <p class="h1">关于我们</p>
                    <p class="h2">About Us</p>
                    <p class="h3">
                        <a href="http://www.haichacha.net/index.php/index/category/index?id=110">关于我们</a>
                    </p>
                </div>
                <div>
                    <div style="width: 126px;height: 126px;background: #fff;display: flex;justify-self: center;align-items: center;">
                        <img style="width: 110px;" src="http://www.haichacha.net/wechat.jpg" alt="">
                    </div>
                    <p style="white-space: nowrap; font-size:12px;" class="h4">扫一扫下载APP</p>
                </div>
            </div>
        </div>
        <div class="beian">
            <p>鲁ICP备<a href="https://beian.miit.gov.cn/">2020039399号-1</a>版权所有：青岛企税无忧信息技术有限公司</p>
        </div>
        <Openvip ref="renewal" v-show="isShow" />
    </div>
</template>

<script>
import {
    MessageBox
} from "element-ui";
import Openvip from "@/components/Openvip";
import {
    mapGetters
} from "vuex";
export default {
    name: "Index",
    components: {
        Openvip
    },
    computed: {
        ...mapGetters({
            oneimpor: "getOne",
            userInfo: "getUser"
        })
    },
    data() {
        return {
            priceList: [],
            datalist: "",
            comprice: "", //企业开通总价
            p: "", //企业会员单价
            setparse: "", //个人开通总价
            num: 1, //人数
            xufeiShow: false,
            isShow: false,
            navlist: [{
                index: 0,
                name: "我的关注",
                router: "/user/care"
            },
            {
                index: 1,
                name: "浏览历史",
                router: "/user/history"
            },
            // {
            // index:2,
            //     name: "我的企业",
            //     router: "/user/company"
            // },
            {
                index: 3,
                name: "我的团队",
                router: "/user/team"
            },
            {
                index: 4,
                name: "购买记录",
                router: "/user/buy"
            },
                // {
                // index:5,
                //     name: "我的发票",
                //     router: "/user/invoice"
                // }
            ]
        };
    },
    created() {
        this.getUserInfo();
    },
    methods: {
        getUserInfo() {
            this.$http.post("app/userInfo").then(res => {
                if (res.data.code == 0) {
                    this.$store.commit("setUser", res.data.data);
                }
            });
        },
        enter() {
            this.xufeiShow = true
        },
        leave() {
            this.xufeiShow = false
        },
        closeVip() { //子组件也调用
            this.isShow = false;
        },
        showvip() {
            this.$http.get("/app/order/singlePriceNew").then((res) => {
                this.priceList = []
                this.isShow = true;
                this.datalist = res.data.data;
                for (var d in this.datalist) {
                    this.priceList.push({
                        month: d,
                        price: this.datalist[d]
                    });
                }
                console.log(this.datalist, 999)
                let json = {
                    memberType: 1, //会员类型（1个人 2企业）
                    payUse: 2, //订单类型（1 新开 2续费）
                    num: 1, //人数
                    memberTypearry: this.priceList, //选中的会员价格数组
                    index: 0, //选中的索引值
                    end: this.userInfo.expirationTime,
                };
                this.$refs.renewal.getSrcList(json);




            });
        },
        exit() {
            MessageBox.confirm("此操作将退出登录, 是否继续?", "提示", {
                confirmButtonText: "退出",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$store.commit("setUser", {});
                    this.$store.commit("setOne", '');
                    this.$router.push("/login");
                })
                .catch(() => { });
        },
        push(url) {
            this.xufeiShow = false;
            this.$router.push({
                path: url
                // query: {
                //   id: id,
                // },
            });
        },
        goto(url) {
            window.location.href = this.$store.state.datanet + url;
        }
    },
};
</script>

<style lang="less" scoped>
.user-drop {
  position: relative;

  .drop-link {
    padding: 30px 0;
    color: #fff;
    user-select: none;
    cursor: pointer;

    img {
      display: inline-block;
      vertical-align: middle;
      margin-right: 6px;
    }
  }

  .dropdown-con {
    position: absolute;
    top: 98px;
    right: 0;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0px 3px 8px rgba(177, 177, 177, 0.4);
    z-index: 2003;
    padding-bottom: 10px;

    &::after {
      position: absolute;
      content: "";
      top: -8px;
      z-index: 10;
      left: 70%;
      width: 0;
      height: 0;
      border-width: 0 8px 10px;
      border-style: solid;
      border-color: transparent transparent #f1f1f1;
    }

    .dropdown-item {
      margin: 0;
      padding: 0;

      li {
        padding-left: 20px;
        line-height: 34px;
        font-size: 14px;
        cursor: pointer;

        &:hover {
          background-color: #eef3ff;
        }
      }
    }
  }
}

.el-dropdown-link {
  cursor: pointer;
  outline: none;

  img {
    display: inline-block;
    vertical-align: middle;
    margin-right: 5px;
  }
}

.user-vip {
  width: 250px;
  position: relative;
  z-index: 11;

  dt {
    background: url("../assets/img/user_bg.png") no-repeat;
    padding: 20px;
    font-size: 16px;
    border-radius: 10px 10px 0 0;
    margin-bottom: 0;

    span {
      margin-top: 8px;
      display: inline-block;
      background: #ebc17d url("../assets/img/vip.png") 10px 4px no-repeat;
      font-size: 10px;
      padding: 0 10px 0 25px;
      height: 20px;
      border-radius: 10px;
      line-height: 20px;
      color: #fff;

      &.company {
        background-color: #4b79e1;
      }

      &.normal {
        background: linear-gradient(to right, #9c9c9c, #797978);
        position: relative;

        &::after {
          position: absolute;
          top: 4px;
          left: 10px;
          content: "";
          width: 12px;
          height: 11px;
          background: url("../assets/img/vip.png") no-repeat;
        }
      }
    }
  }

  dd {
    margin: 14px 20px 10px 20px;
    padding-bottom: 12px;
    border-bottom: #eeeeee 1px solid;
    line-height: 26px;
    color: #666;
    font-size: 14px;

    button {
      float: right;
      width: 70px;
      height: 26px;
      background-color: #0066e5;
      color: #fff;
      font-size: 12px;
      border-radius: 4px;
    }
  }
}

.head-main {
  width: 100%;
  height: 80px;
  background-color: #0c1f3d;

  .main_in {
    width: 1200px;
    margin: 0 auto;
    height: 80px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    > div {
      display: flex;
      align-items: center;
    }

    .main_in_left {
      justify-content: flex-start;

      img {
        width: 170px;
        margin-right: 20px;
      }

      a {
        font-size: 16px;
        color: #ffffff;

        &:hover {
          color: #fff;
        }

        i {
          margin-right: 5px;
        }
      }
    }

    .main_in_right {
      nav {
        display: inline-block;
        width: 160px;

        .menu {
          li {
            float: left;
            margin-right: 30px;
            font-size: 14px;

            &.vip {
              color: #ffe1a6;
              cursor: pointer;

              a {
                color: #ffe1a6;

                span {
                  font-weight: bold;
                  margin-right: 3px;
                }
              }
            }

            a {
              color: #fff;
            }
          }
        }
      }

      .usinfo {
        margin-right: 60px;

        button {
          width: 108px;
          height: 38px;
          background: #3779ff;
          border-radius: 19px;
          color: #fff;
          font-size: 16px;
        }

        a {
          font-size: 16px;
          color: #ffffff;
        }
      }

      .el-dropdown {
        font-size: 16px;
        color: #ffffff;
        padding: 20px 0;
      }
    }
  }
}

.footer {
  background-color: #212121;
  width: 100%;
  padding: 40px 0;

  .footer_in {
    width: 1080px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;

    div {
      p {
        color: #fff;
      }

      .h1 {
        font-size: 16px;
        font-weight: bold;
      }

      .h2 {
        color: #ffffff;
        opacity: 0.3;
        margin: 15px 0 25px 0;
        font-size: 14px;
      }

      .h3 {
        color: #999999;
        margin-bottom: 10px;
        font-size: 12px;

        a {
          color: #999999;
        }
      }

      .address {
        s {
          text-decoration: none;
          padding-right: 10px;
          border-right: 2px solid #666;
          margin-right: 10px;
          cursor: pointer;

          &:last-child {
            border-right: 0;
          }

          &.current {
            color: #fff;
          }
        }
      }

      .h4 {
        color: #999999;
        width: 100%;
        text-align: center;
        margin-top: 10px;
      }

      img {
        margin: 0 auto;
      }

      &:first-child {
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          width: 200px;
        }
      }
    }
  }
}

.beian {
  width: 100%;
  height: 30px;
  background-color: gray;
  overflow: hidden;

  p {
    font-size: 12px;
    line-height: 30px;
    color: #ffffff;
    text-align: center;

    a {
      color: #ffffff;

      &:hover {
        color: #0056d8;
      }
    }
  }

  p:last-child {
    margin-left: 15px;
  }
}
</style>
